import {Helmet} from 'react-helmet';
import AboutUs from "../aboutus";
import Contact from "../contact";

const faqsContent = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is email marketing?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Email marketing is a strategy that uses emails to promote your business’s products or services, build customer relationships, and nurture leads through targeted campaigns."
      }
    },
    {
      "@type": "Question",
      "name": "Why is email marketing important for businesses?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Email marketing is cost-effective, measurable, and helps maintain direct communication with your audience — making it one of the highest ROI marketing channels."
      }
    },
    {
      "@type": "Question",
      "name": "Do you write and design email templates?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I provide custom email content, engaging subject lines, and responsive HTML email designs that work across all devices and email clients."
      }
    },
    {
      "@type": "Question",
      "name": "Can you manage my entire email campaign?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I can plan, write, design, and schedule your email campaigns — including analytics tracking and performance optimization."
      }
    },
    {
      "@type": "Question",
      "name": "What email marketing tools do you work with?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I work with Mailchimp, Sendinblue, ConvertKit, Klaviyo, ActiveCampaign, and other popular platforms depending on your business needs."
      }
    },
    {
      "@type": "Question",
      "name": "Can you set up automated email workflows?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. I create automation for welcome sequences, cart abandonment, re-engagement, follow-ups, and lead nurturing funnels."
      }
    },
    {
      "@type": "Question",
      "name": "Is email marketing suitable for small businesses?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, it’s especially effective for small businesses as it helps build loyalty, increase conversions, and communicate regularly with customers at a low cost."
      }
    },
    {
      "@type": "Question",
      "name": "Will you help with email list segmentation?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I segment your email list based on behavior, purchase history, and engagement to deliver personalized and effective email content."
      }
    },
    {
      "@type": "Question",
      "name": "Can you track and report email campaign performance?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I provide reports on open rates, click-through rates, conversions, and offer recommendations for improvements."
      }
    },
    {
      "@type": "Question",
      "name": "How do I get started with your email marketing service?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can contact me through my website or WhatsApp. We’ll discuss your goals, and I’ll create a tailored email marketing strategy for your business."
      }
    }
  ]
}

function App1() {
  return (
   <>
   <Helmet>
    <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
<title>Email Marketing Services in Gurgaon | Pankaj - Freelance Digital Marketer</title>

<meta name="description" content="Reach your customers directly with result-oriented email marketing services. Newsletters, automation, lead nurturing & campaign setup by Pankaj in Gurgaon." />

<meta name="keywords" content="email marketing gurgaon, freelance email marketer, email automation services, mailchimp expert, email campaigns india, lead nurturing, email marketing for small business, email strategy, newsletter writing, marketing automation specialist" />

<meta property="og:title" content="Email Marketing Services in Gurgaon | Pankaj" />
<meta property="og:description" content="Boost engagement and conversions with personalized email marketing campaigns. From strategy to automation — managed by Pankaj, freelance expert in Gurgaon." />
<meta property="og:site_name" content="Pankaj | Freelance Digital Marketer" />
<meta property="og:url" content="https://www.pankj.com/email-marketing" />
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />

<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Email Marketing Services in Gurgaon | Pankaj" />
<meta name="twitter:description" content="Result-driven email marketing services — newsletters, automation, and list segmentation tailored for your business." />

<link rel="canonical" href="https://www.pankj.com/email-marketing" />

</Helmet>
    <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
{/*                <source src="assets/img/bg.mp4" type="video/mp4" />*/}
                <source src="assets/img/pankaj-web-designer2.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />

 <h1 className="multiple_effects fzsml" id="text3d">Email Marketing</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" rel="noreferrer" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/123.png" alt="best web designer in gurgaon" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   



    <main id="main">

 <section id="pageContent" className="pageContent">

      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Email Marketing</h2>
        </header>

        <div className="row">
          <div className="col-lg-12">
<div class="hero-section py-5 text-white text-center">
  <h2>Email Marketing Services in Gurgaon</h2>
  <p>Grow your business with targeted, automated, and result-oriented email campaigns crafted by a freelance expert.</p>
  <a href="/contact" class="btn btn-light mt-3">Book a Free Consultation</a>
</div>

<div class="intro-section py-5">
  <h2>Boost Engagement with Powerful Email Campaigns</h2>
  <p>Email marketing is one of the most effective digital marketing channels. It helps you stay connected with your audience, nurture leads, promote products, and build long-term customer relationships — all at a low cost.</p>
  <p>I offer end-to-end email marketing services to businesses in Gurgaon, Delhi NCR, and beyond. Whether you're just starting or want to optimize your current campaigns, I can help.</p>
</div>

<div class="services-section py-5">
  <h2>What’s Included in My Email Marketing Services</h2>
  <ul>
    <li>✅ Email Strategy Planning</li>
    <li>✅ Newsletter Creation & Automation</li>
    <li>✅ Welcome Series & Follow-up Campaigns</li>
    <li>✅ Email Copywriting & Subject Lines</li>
    <li>✅ HTML Email Design (Mobile-Friendly)</li>
    <li>✅ List Building & Segmentation</li>
    <li>✅ Campaign Scheduling & Sending</li>
    <li>✅ Performance Reports & Optimization</li>
  </ul>
</div>

<div class="why-me-section py-5">
  <h2>Why Choose Me for Email Marketing?</h2>
  <p>✔ 11+ years of digital marketing experience</p>
  <p>✔ Freelance — personalized attention, no agency markup</p>
  <p>✔ Expertise with Mailchimp, Sendinblue, ConvertKit, Klaviyo, and more</p>
  <p>✔ Proven results for eCommerce, service-based, and local businesses</p>
</div>

<div class="faqs-section py-5">
  <h2>Email Marketing FAQs</h2>

  <div class="faq-item">
    <h3>Do you write and design the email campaigns?</h3>
    <p>Yes, I handle everything — strategy, content writing, and responsive email design to match your branding.</p>
  </div>

  <div class="faq-item">
    <h3>Can you automate email sequences?</h3>
    <p>Absolutely. I set up welcome flows, cart abandonment, re-engagement, and lead nurturing campaigns using tools like Mailchimp or Sendinblue.</p>
  </div>

  <div class="faq-item">
    <h3>What results can I expect?</h3>
    <p>Email marketing drives high ROI with better engagement and retention. I also provide detailed analytics and improvement tips after each campaign.</p>
  </div>

  <div class="faq-item">
    <h3>Do you offer services for international clients?</h3>
    <p>Yes, I work remotely with clients across India and abroad. Communication is simple via WhatsApp, email, or Zoom.</p>
  </div>

  <div class="faq-item">
    <h3>How do I get started?</h3>
    <p>Just message me on WhatsApp or fill out the contact form. I’ll understand your goals and send you a custom plan and pricing.</p>
  </div>
</div>

<div class="cta-section text-center py-5">
  <h2>Ready to Grow with Email Marketing?</h2>
  <p>Let’s create smart, automated email campaigns that convert leads into loyal customers.</p>
  <a href="/contact" class="btn btn-success mt-3">Start Now</a>
</div>

          </div>

        </div>
      </div>

    </section>
    <Contact /> 
    </main>
    </>
  );
}
export default App1;
